<template>
<!-- 头部组件 -->
  <div class="header_box">
    <div class="Header_url">
      <div class="Header_url_bx">
        <a target="_blank" href="https://www.qudong.com/">驱动中国</a>
        <a target="_blank" href="https://tousu.qudong.com/">鹰眼投诉</a>
        <a target="_blank" href="https://www.qudonghao.cn/">驱动号</a>
      </div>
    </div>
    <div class="Header_bx">
      <div class="Header_bx_left">
        <a href="/">
        <img src="../assets/img/header_logo.png" alt="">
        </a>
      </div>
      <div class="Header_bx_content">
        <ul class="nav">
          <li v-for="(item,index) in guides"  :key="index">
            <router-link :to="item.link" class="nav-a">{{item.name}}</router-link>
            <a href="https://top.qudong.com" target="_blank" @click="changes(index)" class="nav-a"  :class="{active:index == num}" v-if="item.id==3">榜单</a>
          </li>
        </ul>
      </div>
      <div class="Header_bx_right">
          <div class="G_reg" v-if="Token==null">
              <span @click="Go_login">登录/</span>
              <a href="https://www.qudong.com/user/reg.html" target="_blank"><span>注册</span></a>
          </div>
          <div v-else class="Header_bx_rights">
            <el-badge :value="msgnum==0?'':msgnum" class="item" @click.native="Go_Msg">
              <i class="el-icon-message" style="font-size:24px"></i>
            </el-badge>
             <div class="userimgurls_box" v-if="isbusiness==0"> 
              <img class="userimgurl" :src="userimgurl" alt="">
            </div>
            <div class="userimgurls_box" v-if="isbusiness==1">
              <img class="userimgurls" src="../assets/img/zhuanjia_headerimg.png" alt="">
              <img class="userimgurl" :src="userimgurl" alt="">
            </div>
            <div class="userimgurls_box" v-if="isbusiness==2">
              <img class="userimgurls" src="../assets/img/jigou_headerimg.png" alt="">
              <img class="userimgurl" :src="userimgurl" alt="">
            </div>
            <div id="user">
            <el-dropdown  @command="handleCommand">
              <span class="el-dropdown-link">
                 <span>{{usernickname}}</span><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  command="a">个人中心</el-dropdown-item>
                <el-dropdown-item command="b">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "../assets/js/eventBus.js"
import {userInfos,msg} from "@/api/api"
export default {
  name: "Header",
  data() {
    return {
      num:0,
      guides: [
        {
          id: 0,
          name: "首页",
          link: "/",
        },
        {
          id: 1,
          name: "专利转让",
          link: "/PatentTransfer",
        },
        {
          id: 2,
          name: "研究报告",
          link: "/Research",
        },
        {
          id: 3,
          name: "科研资讯",
          link: "/Scientific",
        },
        // {
        //   id: 4,
        //   name: "榜单",
        //   link: "/Report",
        // },
        {
          id: 5,
          name: "智库",
          link: "/ThinkTank",
        },
        {
          id: 6,
          name: "关于",
          link: "/Abouts",
        },
      ],
      usernickname:'',
      Token:localStorage.getItem("token"),
      userimgurl:'',
      isbusiness:'',
      isapply_info:'',
      msgnum:'',
      // xiongdi:'我是aaaa'
    };
  },
  methods:{
    changes(index) {
      this.num = index;
      // ////console.log(index);
      // ////console.log(this.num)
    },
    // 消息数量
    Msg(){
      if(this.Token!=null){
         msg({}).then((res) => {
         ////console.log(res);
         this.msgnum=res.data.data;
        });
      }
      
    },
    // 去消息中心
    Go_Msg(){
       this.$router.push('/PersonalCenter/CommentsManage')
    },
      Go_login(){
        this.$router.push('/login')
      },
       handleCommand(command) {
      //////console.log(command);
      if(command == "a"){
       this.$router.push({ name: "PersonalCenter" });
      }
      if (command == "b") {
        this.$confirm("确认是否退出登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            setTimeout(() => {
              localStorage.clear(); //
              location.href = "/";
              this.$message({
                type: "success",
                message: "退出成功!",
              });
            }, 300);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },    
  },
  created(){  
      this.Msg();
     ////console.log(this.Token);
     if(this.Token!=null){
       userInfos({}).then((res) => {
      //console.log(res);
      //  0普通
      // 1专家
      // 2机构
     this.isbusiness = res.data.data.business;
      this.isapply_info=res.data.data.apply_info;
      this.usernickname=res.data.data.nickname; 
      if(res.data.data.headimgurl==''){
          this.userimgurl=res.data.data.default_img
      }else if(res.data.data.headimgurl==null){
        this.userimgurl=res.data.data.default_img
      }else{
        this.userimgurl=res.data.data.headimgurl;
      }
    });
     }
    
  }
};
</script>

<style scoped>
.header_box{
    background:#fff;
}
.Header_url {
  width: 100%;
  height: 28px;
  background: #f5f5f5;
}
.Header_url_bx {
  width: 1200px;
  height: 28px;
  line-height: 28px;
  margin: 0 auto;
}
.Header_url_bx a {
  color: #666;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  margin-right: 26px;
}
.Header_bx {
 width: 1200px;
    height: 85px;
    background: #fff;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.nav-a:hover{
  background: #3463db;
  color:#fff;
}

.Header_bx_content{
  margin-right:50px;
}
.nav {
 justify-content: space-around;
    display: flex;
    margin-top: 5px;
}
.nav li{
  /* background: #3463db; */
    border-radius: 5px;
    color:#333;
    height: 35px;
    line-height: 35px;
    margin-right:10px;
}
.nav .nav-a {
 padding: 3px 13px;
    font-size: 20px;
    border-radius: 5px;
}
.router-link-exact-active {
  background: #3463db;
  font-size: larger;
  color: aliceblue;
}

/* .G_reg{
color: #3463DB;
} */
.G_reg span{
    color: #3463DB;
font-weight: bold;
font-family: Source Han Sans CN;
font-size: 16px;
cursor: pointer;
}
.userimgurl{
  width:44px;
  height:44px;
  border-radius:50%;
position:absolute;
top:8px;
left:0;right:5px;
bottom:0;
margin:auto;
}
.userimgurls{
  position:relative;
  z-index:111;
}
.userimgurls_box{
 width:53px;
  height:56px;
  position:relative;
  /* z-index:111; */
}
.Header_bx_rights{
  display:flex;
  align-items: center;
}
#user {
  cursor: pointer;
}
#user .user_img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin-left: 30px;
}
.item{
  cursor: pointer;
  margin-right:30px;
  margin-top:8px;
}

.el-dropdown-link{
  display:flex;
  align-items: center;
}
.el-dropdown-link span{
  width:66px;
   overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>